import * as React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const Partners = ({ title, description, items }) => (
  <section className="bg-white">
    <div className="max-w-screen-xl mx-auto py-16 px-4">
      <header className="ctnr-half richtext text-center">
        <h2 className="h0">{title}</h2>
        <p>{description}</p>
      </header>

      <div className="max-w-screen-lg mx-auto flex flex-wrap justify-center gap-4 mt-16">
        {items?.map((item, key) => !!item.image?.asset && (
          <GatsbyImage
            className="basis-[225px] <md:basis-[150px] multiply"
            image={getImage(item.image.asset)}
            objectFit="contain"
            alt={item.alt}
            key={key}
          />
        ))}
      </div>
    </div>
  </section>
)

export default Partners
